import { useState, useEffect } from "react";
import { validateContactUsForm } from "../../validations/contactUsForm";
import { useToastPromise } from "../../components/toastPromise";
import { ContactUsController } from "../../controllers/contactUsController";
import { Textbox } from "../../components/textbox";
import { PopupDialog } from "../../components/popupDialog";
import Button from "@mui/material/Button";

export const ContactUs = ({
  user,
  isOpen = false,
  handleClose,
  getAll,
  selectedData,
}) => {
  const toastPromise = useToastPromise();
  const initialInputs = {
    contactName: "",
    contactNum: "",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleTextChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    setInputs(initialInputs);
    setErrors({});
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateContactUsForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    saveContactUs();
  };
  const saveContactUs = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        selectedData?.id
          ? ContactUsController.update({
              parameters: {
                ...inputs,
                id: selectedData.id,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : ContactUsController.add({
              parameters: {
                ...inputs,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        console.debug(data);
        return data;
      },
      errorMessage: (data) => data,
    }).finally(() => {
      setLoading(false);
      handleClose();
      resetForm();
      getAll();
    });
  };
  useEffect(() => {
    if (selectedData) {
      setInputs({
        contactName: selectedData.contactName,
        contactNum: selectedData.contactNum,
      });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  return (
    <PopupDialog
      name="contactUs"
      open={isOpen}
      onClose={() => {
        handleClose();
        resetForm();
      }}
      title={
        selectedData ? "Update Contact Us Detail" : "Add New Contact Us Detail"
      }
      neutralAction={handleClose}
      positiveAction={
        <Button onClick={handleSubmit} disabled={loading}>
          {loading
            ? selectedData
              ? "Updating"
              : "Adding"
            : selectedData
              ? "Update"
              : "Add"}
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          {selectedData ? (
            <Textbox
              type="text"
              name="id"
              value={selectedData.id}
              placeholder="ID"
              readOnly={true}
            />
          ) : null}
          <Textbox
            type="text"
            name="contactName"
            placeholder="Contact Name"
            value={inputs.contactName}
            onChange={handleTextChange}
            errorMsg={errors.contactName}
          />
          <Textbox
            type="text"
            name="contactNum"
            placeholder="Contact Number"
            value={inputs.contactNum}
            onChange={handleTextChange}
            errorMsg={errors.contactNum}
          />
        </form>
      }
    />
  );
};
